import Vue from "vue";

import router from "./router";
import VueToast from "vue-toast-notification";
import store from "@/store";
import App from "./App.vue";
// Import one of the available themes
//import 'vue-toast-notification/dist/theme-default.css';
import "vue-toast-notification/dist/theme-sugar.css";




// import { library } from "@fortawesome/fontawesome-svg-core";
import "font-awesome/css/font-awesome.css"
import '@fortawesome/free-solid-svg-icons'
import '@fortawesome/free-brands-svg-icons';
import '@fortawesome/free-regular-svg-icons';


Vue.use(VueToast);

const app = new Vue({
  router,
  store,
  render: (h) => h(App),
});
app.$mount("#app");
